// extracted by mini-css-extract-plugin
export default {"module-title":"Module_module-title__clwc7"};